import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchFontPacks } from '@/store/slices/templates';
import { selectFontPacks } from '@/store/slices/templates/selectors';
import { useEffect } from 'react';

export const useLoadFontPacks = (channel?: number | null) => {
  const dispatch = useAppDispatch();
  const fontPacks = useAppSelector(selectFontPacks);

  useEffect(() => {
    if (!channel) return;
    dispatch(fetchFontPacks({ channel }));
  }, [channel, fontPacks?.length, dispatch]);
};
